module.exports = __webpack_public_path__ + "static/media/wetsand2.13b2a952.svg";